import { BasicEntity } from "projects/erp-app/src/app/core/models/basic-entity";

export class RelationType extends BasicEntity {
    constructor(relationType?: RelationType) {
        super();
        Object.assign(this, relationType);
    }
}